<template>
  <v-layout
    row
    justify-center
    align-center
    class="authenticator-container"
  >
    <v-card
      min-width="460"
      class="px-4 py-4"
    >
      <div class="text-xs-center">
        <h2 class="headline">
          Exporo Admin Panel
        </h2>
      </div>


      <v-card-actions class="justify-center">
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="warning"
              large
              round
              v-on="on"
              @click="oneLoginAuth"
            >
              <v-icon class="pa-2">
                vpn_key
              </v-icon>

              Sign in with One Login
            </v-btn>
          </template>
          <span>Log in with your exporo account</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { signIn } from '@/utils/auth';

export default {
  name: 'SignIn',
  components: {

  },
  data() {
    return {
      valid: false,
      loading: false,
      passwordVisible: false,
      newPasswordVisible: false,
      isCognitoType: false,
      submitBtnText: 'Sign In',
      email: '',
      password: '',
      newPassword: '',
      totpToken: '',
      totpCode: '',
      error: '',
      appId: '1',
      authType: 'INITIAL',
      applications: [
        { text: 'Exporo AG', value: '1' },
        { text: 'Accontis', value: '4' },
      ],
      currentTab: 'Exporo',
    };
  },
  computed: {
    oneLoginURL() {
      const clientId = window.ONELOGIN_CONFIG.client_id;
      const scope = 'openid+profile+email+groups+params';
      const redirectUri = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

      // eslint-disable-next-line max-len
      return `${window.BASE_API.AUTH}/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=id_token&scope=${scope}&nonce=yUj2l`;
    },
    emailRules() {
      return [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ];
    },
    passwordRules() {
      return {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      };
    },
    totpCodeRules() {
      return [
        v => !!v || 'TOTP code is required',
      ];
    },
  },
  watch: {
    $route(to) {
      this.error = '';
      this.checkLoginType(to.query);
    },
  },
  created() {
    this.checkLoginType(this.$route.query);
  },
  methods: {
    oneLoginAuth() {
      localStorage.setItem('Exporo.SignIn.redirect', this.$route.query.redirect || '/');

      window.location.href = this.oneLoginURL;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const username = this.concatUsername(this.appId, this.email);

        try {
          this.loading = true;
          const result = await signIn(username, this.password, this.newPassword, this.totpCode);

          if (!result.type !== 'SIGN_IN_SUCCESS') {
            this.authType = result.type;
            this.totpToken = result.data;
          }
          // set button text
          if (this.authType === 'NEW_PASSWORD_SETUP') {
            this.submitBtnText = 'Set Password';
          }
          if (this.authType === 'MFA_SETUP') {
            this.submitBtnText = 'Verify';
          }

          this.loading = false;
        } catch (err) {
          this.setError(err);
          this.loading = false;
        }
      }
    },
    concatUsername(appId, email) {
      if (this.isCognitoType) {
        return email;
      }

      return `${email}_app_${appId}`;
    },
    setError(err) {
      this.error = err.message || err;
    },
    checkLoginType(query) {
      const { type } = query;
      this.isCognitoType = type === 'cognito';
      this.currentTab = this.isCognitoType ? 'Cognito' : 'Exporo';
    },
  },
};
</script>
<style lang="scss" scoped>
a.v-btn,
a.v-btn:hover {
  text-decoration: none;
}

.v-card__title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #e2e2e2;
}

.v-card__text {
  width: 100%;
  border-bottom: 1px solid #e2e2e2;
}

.v-card__actions {
  padding: 24px 16px 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/authenticator/SignIn.vue